var map = {
	"./1/symbol_0.png": 43619,
	"./1/symbol_1.png": 53786,
	"./1/symbol_10.png": 9216,
	"./1/symbol_11.png": 33417,
	"./1/symbol_12.png": 85234,
	"./1/symbol_2.png": 13681,
	"./1/symbol_3.png": 81640,
	"./1/symbol_4.png": 83636,
	"./1/symbol_5.png": 85470,
	"./1/symbol_6.png": 5845,
	"./1/symbol_7.png": 94220,
	"./1/symbol_8.png": 98235,
	"./1/symbol_9.png": 76690,
	"./2/symbol_0.png": 94794,
	"./2/symbol_1.png": 56032,
	"./2/symbol_10.png": 43003,
	"./2/symbol_11.png": 28178,
	"./2/symbol_12.png": 59145,
	"./2/symbol_2.png": 87896,
	"./2/symbol_3.png": 9025,
	"./2/symbol_4.png": 91310,
	"./2/symbol_5.png": 36887,
	"./2/symbol_6.png": 78780,
	"./2/symbol_7.png": 61669,
	"./2/symbol_8.png": 67138,
	"./2/symbol_9.png": 88267,
	"./3/symbol_0.png": 32941,
	"./3/symbol_1.png": 76644,
	"./3/symbol_10.png": 89086,
	"./3/symbol_12.png": 97836,
	"./3/symbol_2.png": 31295,
	"./3/symbol_3.png": 51318,
	"./3/symbol_4.png": 51145,
	"./3/symbol_5.png": 79968,
	"./3/symbol_6.png": 58299,
	"./3/symbol_7.png": 60434,
	"./3/symbol_8.png": 89589,
	"./3/symbol_9.png": 20492,
	"./4/symbol_0.png": 89164,
	"./4/symbol_1.png": 25077,
	"./4/symbol_10.png": 97745,
	"./4/symbol_12.png": 94659,
	"./4/symbol_2.png": 39326,
	"./4/symbol_3.png": 91815,
	"./4/symbol_4.png": 12200,
	"./4/symbol_5.png": 22417,
	"./4/symbol_6.png": 1306,
	"./4/symbol_7.png": 65411,
	"./4/symbol_8.png": 5188,
	"./4/symbol_9.png": 59085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23849;